import '../../../common/dashboard/filters/single_filters/multiple_values_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.SingleFilters'

class CustomerVisualMode.Filters.SingleFilters.SubTypeFilterView extends
Common.Sessions.Filters.SingleFilters.MultipleValuesFilterView
  @SUBTYPE_ID_ORDER = [
    'facebook_post',
    'fb-post',
    'facebook_comment',
    'fb-comment',
    'facebook_message',
    'fb-message',
    'fb-user',

    'tweet',
    'retweet',
    'quote',
    'twitter_quote',
    'direct-message',
    'twitter_direct_message',
    'tw-user',

    'ig-image',
    'instagram_image',
    'ig-video',
    'instagram_video',
    'ig-comment',
    'instagram_comment',
    'ig-message',
    'instagram_message',
    'ig-user',

    'yt-comment',
    'youtube-comment',
    'yt-user',

    'webchat',

    'email',
    'email-user',

    'li-post',
    'li-comment',
    'li-user',

    'google-my-business-review',
    'google-my-business-reply',

    'whatsapp_message',

    'whatsapp_message-user',

    'apple_app_store_review_comment',

    'gp_review_comment',

    'clipping',

    'google_search',

    'reclameaqui',

    'tiktok-ad'
    'tiktok-post'
    'tiktok-comment'
    'tiktok-user'
  ]

  _selector: (values) ->
    new App.SubTypeSelectView
      options: @_groupedOptions(values)
      editable: @editable
      width: '100%'
      multiple: true
      clearableInput: true

  _groupedOptions: (values) ->
    values = _.sortBy values, (subtype) =>
      @constructor.SUBTYPE_ID_ORDER.indexOf(subtype.get('id'))
    groups = _.groupBy values, (subtype) -> subtype.get('group')
    options = Object.keys(groups).map (group) =>
      {
        title: _.str.humanize(group),
        options: {
          options: @_subtypesForGroup(groups[group]),
          placeholder: @placeholder
          valueProperty: 'id',
          descriptionProperty: 'name',
          selectedOptions: @selectedOptions,
          clearableInput: true
          width: 'inherit'
        }
      }

  _subtypesForGroup: (subtypes) ->
    subtypes.map (subtype) =>
      id: subtype.get('id'),
      name: _.str.capitalize(@_translatedSubtype(subtype))

  _translatedSubtype: (subtype) ->
    @_subtypeTranslator().getSubtypeOnlyTranslation(subtype.get('id'))

  _subtypeTranslator: ->
    @translator ||= new Customer.Filters.SubTypeTranslator()
